import { type CURRENCYCODETYPE, getWalletProps, type IWalletProps } from 'BreetHelpers';
import { selectWallet, useAppSelector } from 'BreetRedux';

export const useUserWalletApi = (currencyCode: CURRENCYCODETYPE | undefined): IWalletProps => {
	const wallet = useAppSelector(selectWallet);

	const userWalletProps = getWalletProps(currencyCode, wallet);

	return userWalletProps;
};
